import { api } from './client';

export const bookmarksApi = {
  // Story bookmark endpoints
  bookmarkMessage: (sessionId, messageId, data) =>
    api.post(`/sessions/${sessionId}/messages/${messageId}/bookmark`, data),
  createSynthesis: (storyId, data) =>
    api.post(`/stories/${storyId}/bookmarks/synthesis`, data),
  list: (storyId, category = null, options) => {
    const url = `/stories/${storyId}/bookmarks${category ? `?category=${category}` : ''}`;
    return api.get(url, options);
  },
  delete: (id) => api.delete(`/bookmarks/${id}`),
  updateCategory: (id, category) =>
    api.patch(`/bookmarks/${id}/category`, { category }),
  updateTitle: (id, userTitle) =>
    api.patch(`/bookmarks/${id}/title`, { user_title: userTitle }),

  // Project Sessions: Project-scoped bookmark endpoints
  bookmarkMessageToProject: (projectId, messageId, data) =>
    api.post(`/projects/${projectId}/bookmarks/message?message_id=${messageId}`, data),
  createProjectSynthesis: (projectId, data) =>
    api.post(`/projects/${projectId}/bookmarks/synthesis`, data),
  listProject: (projectId, category = null, options) => {
    const url = `/projects/${projectId}/bookmarks${category ? `?category=${category}` : ''}`;
    return api.get(url, options);
  },
  listAllProject: (projectId) =>
    api.get(`/projects/${projectId}/bookmarks/all`),

  // Sidebar endpoints (folders + bookmarks combined)
  getStorySidebar: (storyId, options) =>
    api.get(`/stories/${storyId}/bookmarks/sidebar`, options),
  getProjectSidebar: (projectId, options) =>
    api.get(`/projects/${projectId}/bookmarks/sidebar`, options),

  // Folder operations
  move: (bookmarkId, folderId) =>
    api.patch(`/bookmarks/${bookmarkId}/move`, { folder_id: folderId }),
  reorder: (bookmarkId, direction) =>
    api.post(`/bookmarks/${bookmarkId}/reorder`, { direction }),
};
